import { FC, InputHTMLAttributes } from 'react'
import { useTheme } from '@emotion/react'

// styles
import { styles } from './styles'

interface InputBarProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string
  label: string
  error?: boolean
  errorMessage?: string
}

export const InputBar: FC<InputBarProps> = ({
  name,
  label,
  error = false,
  errorMessage = '',
  ...attributes
}) => {
  const theme = useTheme()

  return (
    <div css={styles(theme).input.main}>
      {/* label */}
      <label css={styles(theme).input.label} htmlFor={name}>
        {label}
      </label>

      {/* input */}
      <div css={styles(theme).input.data.main}>
        <input
          css={[
            styles(theme).input.data.shared,

            attributes.value
              ? styles(theme).input.data.filled
              : styles(theme).input.data.empty,

            error && styles(theme).input.data.errored,
          ]}
          id={name}
          {...attributes}
        />
      </div>

      {/* error message */}
      <div
        css={[
          styles(theme).input.error.shared,
          errorMessage
            ? styles(theme).input.error.visible
            : styles(theme).input.error.hidden,
        ]}
      >
        <span
          css={[
            styles(theme).input.error.text.shared,
            errorMessage
              ? styles(theme).input.error.text.visible
              : styles(theme).input.error.text.hidden,
          ]}
        >
          {errorMessage}
        </span>
      </div>
    </div>
  )
}

InputBar.propTypes = {}
